import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
    {
      exact: true,
      path: '/home/sys/authority',
      owner: '/home',
      authority: 'userList',
      component: Loadable({
        loader: () => import('./index'),
        loading: () => <RouteLoading />
      })      
    },
    {
      exact: true,
      path: '/home/sys/authority/:id/edit',
      owner: '/home',
      authority: 'userList',
      component: Loadable({
        loader: () => import('../components/edit'),
        loading: () => <RouteLoading />
      })      
    }

  ];